import React, { useState } from "react";

const Footer = () => {
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Form validation
    if (!message) {
      alert("Please enter your message.");
      return;
    }
    
    // Create mailto link with just the message
    const subject = "Contact from OPENAPIPASS Website";
    const body = message.trim();
    const mailtoLink = `mailto:community@codeforeword.org?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Open email client
    window.location.href = mailtoLink;
    
    // Reset form
    setMessage('');
  };

  return (
    <section className="bg-[#243e63] text-white py-12">
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Contact Form */}
        <div>
          <h3 className="text-2xl font-bold mb-4">GET IN TOUCH</h3>
          <p className="mb-6">
            Please enter your message below and click 'Send Message' to contact us with any issues you have. 
          </p>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <textarea
                name="message"
                value={message}
                onChange={handleChange}
                placeholder="Your message"
                className="w-full p-3 rounded-md text-gray-800"
                rows="6"
              ></textarea>
            </div>
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-md"
            >
              Send Message
            </button>
          </form>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-2xl font-bold mb-4">Contact Info</h3>
          <ul className="space-y-4">
            <li>
              <strong>Email:</strong> community@codeforeword.org
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Footer;